import type { SubscriptionPaymentMethod } from '@/constants/institute';
import { apiClient } from '@/lib/apiClient';
import { compactParams } from '@/lib/queryParams';
import type { ApiSuccess, PaginationMeta } from '@/types/api';
import type { SubscriptionTransaction, SubscriptionTransactionsSummary } from '@/types/institute';

export interface SubscriptionTransactionsParams {
  page: number;
  limit: number;
  /** Institute name or code, receipt number or payment reference. */
  search?: string;
  method?: SubscriptionPaymentMethod;
  /** `2026-27`. */
  periodYear?: string;
  /** `YYYY-MM-DD`, inclusive — the day the money arrived. */
  from?: string;
  to?: string;
}

/** Every network call the subscription-transactions page makes (CLAUDE.md §6). */
export const subscriptionTransactionsApi = {
  list: async (params: SubscriptionTransactionsParams) => {
    const response = await apiClient.get<
      ApiSuccess<{ items: SubscriptionTransaction[]; summary: SubscriptionTransactionsSummary }>
    >('/platform/subscription-payments', { params: compactParams({ ...params }) });
    const { items, summary } = response.data.data;
    const meta: PaginationMeta = response.data.meta ?? {
      page: 1,
      limit: params.limit,
      total: items.length,
      totalPages: 1,
    };
    return { items, summary, meta };
  },
};
